/**
 * The motion of the wizard, from the V7 prototype, section "Le mouvement"
 * (docs/juiscigpt-wizard.md REQ-20). Four durations only: 160 ms for a tap,
 * 240 ms for an exit, 480 ms for an entry, 640 ms for a movement. An entry
 * glides; only the dark elements (the card, the notes) overshoot a little.
 * The reduced-motion setting replaces each with an instant change.
 */
export const WIZARD_GLIDE = {
  duration: 0.48,
  ease: [0.32, 0.72, 0, 1],
} as const;

export const WIZARD_DARK_SPRING = {
  duration: 0.48,
  ease: [0.34, 1.25, 0.64, 1],
} as const;

export const WIZARD_EXIT = {
  duration: 0.24,
  ease: [0.4, 0, 1, 1],
} as const;
